import { DatePipe } from '@angular/common';
import { inject, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrimeNGConfig } from 'primeng/api';
import { ActivosService } from '@/app/services/activos.service';
import { CentroCostosService } from '@/app/services/centro-costos.service';
import { CombustiblesService } from '@/app/services/combustibles.service';
import { CompaniaLmService } from '@/app/services/compania-lm.service';
import { CompaniaService } from '@/app/services/compania.service';
import { CuentasLmService } from '@/app/services/cuentas-lm.service';
import { EquiposService } from '@/app/services/equipos.service';
import { EstacionesService } from '@/app/services/estaciones.service';
import { EstatusService } from '@/app/services/estatus.service';
import { FamiliaequipoService } from '@/app/services/familiaequipo.service';
import { esNumeroActivoValido } from '@/app/services/security/input-validation';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import { SubcuentasService } from '@/app/services/subcuentas.service';
import { UbicacionesLmService } from '@/app/services/ubicaciones-lm.service';
import { UnidadNegocioService } from '@/app/services/unidad-negocio.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-editar-activo',
    templateUrl: './editar-activo.component.html',
    styleUrls: ['./editar-activo.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditarActivoComponent {
  private spinner = inject(NgxSpinnerService);

  hasFinished: boolean = false;

  isOldComb : boolean = false;//Bandera para saber si es el comb anterior a cloud

  cuentaContableDebito: string = " ?? - ?? - ?????? - ???? - 0000 - 0000 - 00 ";

  activoRQ = {
    activo: '',
    descripcion: '',
    modelo: '',
    planta: '',
    estado: '',
    anio: '',
    tipo: '', //catalog
    idEstatus:'',
    idFamiliaEquipo: null,//catalogo
    idCondicionEquipo: null,
    capacidad: '',
    idCompaniaLM: '',
    idUnidadNegocioLM: '',
    idCentroCostosLM: '',
    idUbicacionLM: '',
    idCuentaLM: '',
    idSubCuentaLM: '',
    idEquipoLM: 1,
    idIntercompaniaLM: 1,
    compania: '', //catalogo
    ubicacion: '', //catalogo
    tipoCombustible: '', //catalogo
    marca: '',
    numeroActivoCORE: '', 
    numeroMotor: '',
    numeroSerie: '',
    factura: '',
    fechaFactura: null,
    fechaFacturaText: '',
    valorFactura: '',
    costoTotal: '',
    costoAcumuladoAnual: '',
    valorActual: '',
    creadoPor: '',
    isActivo: false
  }

  //catalogos
  combustiblesCatalog: any[] =[];
  companiasCatalog: any[] =[];
  familiasCatalog: any[] =[];
  tiposEquiposCatalog: any[] = [];
  condicionesEquiposCatalog: any[] = [];
  estacionesCatalog: any[] = [];
  estatusCatalog: any[] = [];

  //cuentaLM
  companiasLM: any[] = [];
  unidadNegocio: any[] = [];
  centroCostos: any[] = [];
  ubicacionLM: any[] = [];
  cuentasLM: any[] = [];
  subCuentasLM: any[] = [];

  constructor(
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<EditarActivoComponent>,
    private config: PrimeNGConfig,
    private combustiblesService: CombustiblesService,
    private companiaService: CompaniaService,
    private familiaEquipoService: FamiliaequipoService,
    private equiposService: EquiposService,
    private activosService: ActivosService,
    private estacionesService: EstacionesService,
    private toastr: ToastrService,
    private router: Router,
    private centroCostosService: CentroCostosService,
    private companiaLMService: CompaniaLmService,
    private cuentasLMService: CuentasLmService,
    private subCuentasService: SubcuentasService,
    private ubicacionesLMService: UbicacionesLmService,
    private unidadNegocioService: UnidadNegocioService,
    private userTokenReaderService: TokenReaderService,
    private estatusService: EstatusService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){

  this.spinner.show();
   
    this.obtenerTipoEquipo(); 
   this.obtenerCondicionEquipo();
   this.getFamiliaEquipo();
   this.obtenerCombustibles();
   this.obtenerCompania();
   this.obtenerEstaciones();
   this.getEstatus();
   //
   this.getCentroCostosLM();

    //console.log(data);
    let {numActivo} = data;
    this.activoRQ.activo = numActivo;

  }
  ngOnInit(): void {
    this.config.setTranslation ({
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      clear: 'Borrar'
    });
  }

  getDetalleActivo(numActivo: string){
    // Validación de entrada (se repite en el servicio, que es el punto central).
    if(!esNumeroActivoValido(numActivo)){
      this.spinner.hide();
      this.toastr.error('El número de activo no es válido.', 'Dato no válido');
      return;
    }

    this.activosService.getDetalleActivo(numActivo).subscribe({
      next: (data: any) => {
        if(data != null && data.ActivoDetalle != null){
          let info = data.ActivoDetalle[0];
          this.activoRQ.activo = info['Activo'];
          this.activoRQ.descripcion = info['Descripcion'];
          this.activoRQ.modelo = info['Modelo'];
          this.activoRQ.planta = info['Planta'];
          this.activoRQ.estado = info['Estado'];
          this.activoRQ.capacidad = info['Capacidad'];
          this.activoRQ.marca = info['Marca'];
          this.activoRQ.numeroMotor = info['NumeroMotor'];
          this.activoRQ.numeroSerie = info['NumeroSerie'];
          this.activoRQ.factura = info['Factura'];

          this.activoRQ.valorActual = info['ValorActual'];
          
          this.activoRQ.fechaFacturaText = this.datePipe.transform(info['FechaFactura'], 'dd/MM/yyyy')! !== '01/01/1900' ? this.datePipe.transform(info['FechaFactura'], 'dd/MM/yyyy')! : '';
          this.activoRQ.fechaFactura = this.datePipe.transform(info['FechaFactura'], 'dd/MM/yyyy')! !== '01/01/1900' ? info['FechaFactura'] : null;
          
          this.activoRQ.costoTotal = info['CostoTotal'] !== 0 ? info['CostoTotal'] : '';
          this.activoRQ.costoAcumuladoAnual = info['CostoAcumuladoAnual'] !== 0 ? info['CostoAcumuladoAnual'] : '';
          this.activoRQ.valorFactura =  info['ValorFactura'] !== 0 ? info['ValorFactura'] : '';
          this.activoRQ.numeroActivoCORE =  info['NumeroActivoCORE'] !== 0 ? info['NumeroActivoCORE'] : '';
          this.activoRQ.anio =  info['Anio'] !== 0 ? info['Anio'] : '';
          this.activoRQ.tipo =  info['Tipo'] !== 0 ? info['Tipo'] : '';
          
          this.activoRQ.idCondicionEquipo =  info['idCondicionEquipo'] !== 0 ? info['idCondicionEquipo'] : null;
          this.activoRQ.idCompaniaLM =  info['idCompaniaLM'] !== 0 ? info['idCompaniaLM'] : '';
          this.activoRQ.idUnidadNegocioLM =info['idUnidadNegocioLM'] !== 0 ? info['idUnidadNegocioLM'] : '';
          this.activoRQ.idCentroCostosLM = info['idCentroCostosLM'] !== 0 ? info['idCentroCostosLM'] : '';
          this.activoRQ.idUbicacionLM = info['idUbicacionLM'] !== 0 ? info['idUbicacionLM'] : '';
          this.activoRQ.idCuentaLM = info['idCuentaLM'] !== 0 ? info['idCuentaLM'] : '';
          this.activoRQ.idSubCuentaLM = info['idSubCuentaLM'] !== 0 ? info['idSubCuentaLM'] : '';
          this.activoRQ.compania = info['Compania'] !== 0 ? info['Compania'] : '';
          this.activoRQ.ubicacion = info['Ubicacion'] !== 0 ? info['Ubicacion'] : '';
          this.activoRQ.tipoCombustible =  info['TipoCombustible'] !== 0 ? info['TipoCombustible'] : '';
          
          this.activoRQ.idEquipoLM = info['idEquipoLM'] !== 0 ? info['idEquipoLM'] : 1;
          this.activoRQ.idIntercompaniaLM = info['idIntercompaniaLM'] !== 0 ? info['idIntercompaniaLM'] : 1;

          this.activoRQ.idFamiliaEquipo =  info['idFamiliaEquipo'] !== 0 ? info['idFamiliaEquipo'] : null;
          this.activoRQ.idEstatus =  info['idEstatus'] !== 0 ? info['idEstatus'] : '';

          // this.activoRQ.isActivo =  info['IsActivo'];

          let selectedDefault = this.estatusCatalog.length > 0 ? this.estatusCatalog.find(x => x['label'].toUpperCase() === 'OPERATING')['value'] : null;
          if(selectedDefault != null && this.activoRQ.idEstatus === ''){
            this.activoRQ.idEstatus = selectedDefault;
          }

          this.cuentaContableDebito = " ?? - ?? - ?????? - ???? - 0000 - 0000 - 00 ";
          this.getCCDebito(this.activoRQ.idCompaniaLM, this.companiasLM, 0);
          this.getCCDebito(this.activoRQ.idCentroCostosLM, this.centroCostos, 1);
          this.getCCDebito(this.activoRQ.idUbicacionLM, this.ubicacionLM, 2);
          this.getCCDebito(this.activoRQ.idCuentaLM, this.cuentasLM, 3);
        }
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  selectFecha(event: any){
    this.activoRQ.fechaFactura = event;
  }

  clearFecha(event: any){
    this.activoRQ.fechaFactura = null;
    this.activoRQ.fechaFacturaText = '';
  }

  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas actualizar el activo?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.insertActivo();
        }
      });
    }
  }

  insertActivo(){
    this.spinner.show();
    this.activoRQ.creadoPor = this.userTokenReaderService.getUserData().idUsuario;
    this.activosService.insertActivo(this.activoRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Activo actualizado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();
        });
      },
      error: (err) =>{
        this.spinner.hide();
        if (err.status == 401) {
          this.toastr.error(
            'Tu sesión expiró o no tienes permiso para ver esta página.',
            'Acceso no autorizado'
          );
          this.router.navigate(['/login']);
        } else {
          if (err.error) {
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo.Error, 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha guardado los cambios. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }
  }

  getCCDebito(value: string, lista: any[], posicion: number){
    let defaults = ['??', '??','??????','????','????','?????']
    let arrayCuenta = this.cuentaContableDebito.split('-');

    if(value != ''){
      //validacion cuando la lista llega vacia o no se encuentra el item
      let item = (lista != null && lista.length > 0) ? lista.find( x => x['value'] == value) : null;
      let selected = (item != null && item['description'] != null) ? item['description'] : null;
      if(selected != null ){
        arrayCuenta[posicion] = ` ${selected} `;
      }else{
        arrayCuenta[posicion] = ` ${defaults[posicion]} `;
      }
      let newCredito = '';
      arrayCuenta.forEach( (item,index) => {
        newCredito = `${newCredito}${item}`;
        if(index <= (arrayCuenta.length-2)) newCredito = `${newCredito}-`;
      });
      this.cuentaContableDebito = newCredito;
    }
  }


  //#region listas
  //catalogos
  obtenerTipoEquipo(){
    this.equiposService.obtenerTipoEquipo().subscribe({       
      next: (data: any) => {
        if(data != null && data.TipoEquipos != null){
           this.tiposEquiposCatalog = data.TipoEquipos.filter( (i: any) => i['Nombre'] != '').map( (i: any) => {return {'label': i.Nombre, 'value': i.idTipoEquipo} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.tiposEquiposCatalog = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  obtenerCondicionEquipo(){
    this.equiposService.obtenerCondicionEquipo().subscribe({       
      next: (data: any) => {
        if(data != null && data.CondicionEquipo != null){
           this.condicionesEquiposCatalog = data.CondicionEquipo.filter( (i: any) => i['Nombre'] != '').map( (i: any) => {return {'label': i.Nombre, 'value': i.idCondicionEquipo} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.condicionesEquiposCatalog = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getFamiliaEquipo(){
    this.familiaEquipoService.getFamiliaEquipo().subscribe({       
      next: (data: any) => {
        if(data != null && data.Familia != null){
           this.familiasCatalog = data.Familia.filter( (i: any) => i['valor'] != '').map( (i: any) => {return {'label': i.valor, 'value': i.idFamiliaEquipo} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.familiasCatalog = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }
  obtenerCombustibles(){
    this.combustiblesService.obtenerCombustibles().subscribe({       
      next: (data: any) => {
        if(data != null && data.Combustible != null){
           this.combustiblesCatalog = data.Combustible.filter( (i: any) => i['tipo'] != '').map( (i: any) => {return {'label': i.tipo, 'value': i.idCombustible} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.combustiblesCatalog = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  obtenerCompania(){
    this.companiaService.obtenerCompania().subscribe({       
      next: (data: any) => {
        if(data != null && data.Companias != null){
           this.companiasCatalog = data.Companias.filter( (i: any) => i['clave'] != '').map( (i: any) => {return {'label': i.clave, 'value': i.idCompania} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.companiasCatalog = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  obtenerEstaciones(){
    this.estacionesService.obtenerEstaciones().subscribe({       
      next: (data: any) => {
        if(data != null && data.Estaciones != null){
          this.estacionesCatalog = data.Estaciones.filter( (i: any) => i['IATA'] != '').map( (i: any) => {return {'label': i.IATA, 'value': i.idEstacion} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.estacionesCatalog = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getEstatus(){
    this.estatusService.getEstatus().subscribe({       
      next: (data: any) => {
        if(data != null && data.Estatus != null){
          this.estatusCatalog = data.Estatus.filter( (i: any) => i['estatus'] != '').map( (i: any) => {return {'label': i.estatus, 'value': i.idEstatus} } ); 

        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.estatusCatalog = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  //CUENTA LM
  getCentroCostosLM(){
    this.centroCostosService.getCentroCostosLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.CentroCostosLM != null){
           this.centroCostos = data.CentroCostosLM.filter( (i: any) => i['Descripcion'] != '' && i['Activo']).map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor, 'value': i.IdCentroCostosLM, 'activo': i.Activo} } );      
        }
        
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.centroCostos = [];
          this.activoRQ.idCentroCostosLM = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
      complete: () => {
        this.getCompaniaLM();
      }
    });
  }

  getCompaniaLM(){
    this.companiaLMService.getCompaniaLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.CompaniaLM != null){
           this.companiasLM = data.CompaniaLM.filter( (i: any) => i['Descripcion'] != '').map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor, 'value': i.idCompaniaLM} } );    
        }
        
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.companiasLM = [];
          this.activoRQ.idCompaniaLM = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
      complete: () => {
        this.getCuentaLM();
      }
    });
  }

  getCuentaLM(){
    this.cuentasLMService.getCuentaLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.Cuentalm != null){
           this.cuentasLM = data.Cuentalm.filter( (i: any) => i['Descripcion'] != '' && i['Activo']).map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor,'value': i.idCuentaLM, 'activo': i.Activo} } );
        }
        
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.cuentasLM = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
      complete: () => {
        this.getSubCuentaLM();
      }
    });
  }

  getSubCuentaLM(){
    this.subCuentasService.getSubCuentaLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.Subcuentalm != null){
           this.subCuentasLM = data.Subcuentalm.filter( (i: any) => i['Descripcion'] != '' && i['Activo']).map( (i: any) => {return {'label': i.Descripcion,'description': i.Valor, 'value': i.idSubCuentaLM, 'activo': i.Activo} } );
        }
        this.getUnidadNegocioLM();
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.subCuentasLM = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
      complete: () => {
        this.getUnidadNegocioLM();
      }
    });
  }

  getUnidadNegocioLM(){
    this.unidadNegocioService.getUnidadNegocioLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.CompaniaLM != null){
           this.unidadNegocio = data.CompaniaLM.filter( (i: any) => i['Descripcion'] != '').map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor, 'value': i.idUnidadNegocioLM} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.unidadNegocio = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
      complete: () => {
        this.getUbicacionLM();
      }
    });
  }

  getUbicacionLM(){
    this.ubicacionesLMService.getUbicacionLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.UbicacionLM != null){
           this.ubicacionLM = data.UbicacionLM.filter( (i: any) => i['Descripcion'] != '' && i['Activo']).map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor, 'value': i.IdUbicacionLM, 'activo': i.Activo} } );
        }
        this.getDetalleActivo(this.activoRQ.activo);
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.ubicacionLM = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
    });
  }

  getItemSelected(lista: any[], itemSelected: string){
    if(lista != null){
      return lista.find(x => x['value'] == itemSelected)['label'];
    }
    return '';
  }

  getItemDescriptionSelected(lista: any[], itemSelected: string){
    if(lista != null){
      return lista.find(x => x['value'] == itemSelected)['description'];
    }
    return '';
  }

  getChangeCCDebito(event: any, lista: any[], posicion: number){
    let defaults = ['??', '??','??????','????','????','?????','??']
    let arrayCuenta = this.cuentaContableDebito.split('-');
    if(lista != null){
      let selected = lista.find( x => x['value'] == event.value)['description'] != null ?  lista.find( x => x['value'] == event.value)['description'] : null;
      if(selected != null ){
        arrayCuenta[posicion] = ` ${selected} `;
      }else{
        arrayCuenta[posicion] = ` ${defaults[posicion]} `;
      }
    }else{
      arrayCuenta[posicion] = ` ${defaults[posicion]} `;
    }

    let newCredito = '';
    arrayCuenta.forEach( (item,index) => {
      newCredito = `${newCredito}${item}`;
      if(index <= (arrayCuenta.length-2)) newCredito = `${newCredito}-`;
    });
    this.cuentaContableDebito = newCredito;
  }

  //#endregion
}
